import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://newsip.thecodevo.com/api';
const getSessionId = () => {
    let sessionId = sessionStorage.getItem('sessionId');
    if (!sessionId) {
        sessionId = 'sid_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        sessionStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
};

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add interceptors for all requests
api.interceptors.request.use((config) => {
    // Add session ID for view tracking
    config.headers['X-Session-Id'] = getSessionId();

    // ✅ Add token for ALL requests except login
    // The /me endpoint needs the token
    const isLoginEndpoint = config.url.includes('/auth/login');

    if (!isLoginEndpoint) {
        const token = localStorage.getItem('adminToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }

    return config;
});

// Handle 401 unauthorized responses
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Don't redirect on login endpoint
        const isLoginEndpoint = error.config?.url?.includes('/auth/login');

        if (error.response?.status === 401 && !isLoginEndpoint) {
            // Clear token and redirect to login for admin routes
            if (window.location.pathname.includes('/admin')) {
                localStorage.removeItem('adminToken');
                window.location.href = '/admin';
            }
        }
        return Promise.reject(error);
    }
);

export default api;